<template>
    <div style="height: 100vh;overflow: scroll">
        <ul class="gongneng">
            <li><h1>{{title}}</h1></li>
        </ul>


        <div class="table">

            <el-table
                    :data="tableData"
                    border
                    style="width: 100%">
                <el-table-column
                        fixed
                        prop="id"
                        label="编号"
                        width="">
                </el-table-column>
                <el-table-column
                        prop="module"
                        label="模块"
                        width="">
                </el-table-column>
                <el-table-column
                        prop="operator"
                        label="具体操作"
                        width="">
                </el-table-column>
                <el-table-column
                        prop="params"
                        label="参数"
                        width="">
                </el-table-column>
                <el-table-column
                        prop="ip"
                        label="ip地址"
                        width="">
                </el-table-column>
                <el-table-column
                        prop="username"
                        label="操作人"
                        width="">
                </el-table-column>
                <el-table-column
                        prop="time"
                        label="时间"
                        width="">
                </el-table-column>
            </el-table>
            <el-pagination

                    :page-size="10"
                    layout="prev, pager, next"
                    :default-current-page=currentPage
                    @current-change="handleCurrentChange"
                    :current-page=currentPage
                    :total=total
                    ref="pagination"

            >
            </el-pagination>

        </div>


    </div>
</template>

<script>
    import request from "@/utils/request";
    export default {
        name: "new",
        data() {
            return{
                title:"后台操作日志",
                currentPage:1,
                total:"",
                tableData: [],
            }
        },
        methods: {
            handleCurrentChange(val){
                this.getData(val)
            },
            getData(current){
                request.get("/log/"+current).then(res => {
                    this.total=res.data.total;
                    this.tableData=res.data.data;
                    this.currentPage=res.data.currentPage

                })
            },
            handleClick(row) {


                this.$router.push({path:"/backStage_Management/Mate/add",query:{id:row.catId,title:this.title}})

            },

        },
        beforeMount() {
            this.getData(1)
        }


    }
</script>

<style lang="less" scoped>

    .el-menu{
        height:100vh
    }
    .gongneng{
        padding: 20px 0;
        border-bottom: 1px solid #cccccc;
        overflow: hidden;
        li:first-child{
            float: left;
            margin-left: 10px;
        }
        li:last-child{
            float: right;
            margin-right: 10px;
        }
    }
    .xiala{
        padding: 10px;
    }
    .el-table .warning-row {
        background: oldlace;
    }

    .el-table .success-row {
        background: #f0f9eb;
    }
</style>